import { MeshInstance } from "./modelInstance/MeshInstance";
import { GroupInstance } from "./modelInstance/GroupInstance";
import { FurnitureInstance } from "@/state/Furniture";
import { ElementInstance } from "./element/Element";
import { WallConfig } from "@/state/RoomConfig/WallConfig";

export const SELECTED_ITEM_TYPE = {
    FURNITURE: "furniture",
    WALL_PROP: "wallProp",
    WALL: "wall",
    FLOOR: "floor",
} as const;

export type SelectedWall = {
    selectedItemType: typeof SELECTED_ITEM_TYPE.WALL;
    key: string;
};

export type SelectedWallProp = {
    selectedItemType: typeof SELECTED_ITEM_TYPE.WALL_PROP;
    key: string;
    parent?: string;
};

export type SelectedFloor = {
    selectedItemType: typeof SELECTED_ITEM_TYPE.FLOOR;
};

export type SelectedItem =
    | {
          selectedItemType: typeof SELECTED_ITEM_TYPE.FURNITURE;
          instanceId: string; // mesh or element id
          furnitureInstanceId: string;
          groupId?: string;
          isElement?: boolean;
      }
    | SelectedWall
    | SelectedWallProp
    | SelectedFloor;

export const checkIsSelectedWall = (item: SelectedItem): item is SelectedWall =>
    item.selectedItemType === SELECTED_ITEM_TYPE.WALL;

export const checkIsSelectedWallProp = (item: SelectedItem): item is SelectedWallProp =>
    item.selectedItemType === SELECTED_ITEM_TYPE.WALL_PROP;

export const checkIsSelectedWallOrWallProp = (
    item: SelectedItem
): item is SelectedWall | SelectedWallProp =>
    checkIsSelectedWall(item) || checkIsSelectedWallProp(item);

export const createSelectedItem = (
    mesh: MeshInstance | ElementInstance,
    furniture: FurnitureInstance,
    group?: GroupInstance
): SelectedItem => {
    if (furniture.type === "furniture") {
        return {
            selectedItemType: SELECTED_ITEM_TYPE.FURNITURE,
            instanceId: "elementId" in mesh ? mesh.elementId : mesh.id,
            furnitureInstanceId: furniture.id,
            groupId: group?.config.id,
            isElement: "elementId" in mesh,
        };
    }

    return {
        selectedItemType: SELECTED_ITEM_TYPE.WALL_PROP,
        key: furniture.id,
    };
};

export const createSelectedWall = (wall: WallConfig) => {
    return {
        selectedItemType: SELECTED_ITEM_TYPE.WALL,
        key: wall.key,
    };
};
